module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card-header', {
    staticStyle: {
      "transform": "translateX(-12px)"
    },
    attrs: {
      "title": "Name",
      "subTitle": "sub title"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "icon": "person"
    },
    slot: "avatar"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a085e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/muse-ui/cardHeader.vue
// module id = 538
// module chunks = 1